import Map from "./Map.Container";

export default Map;